module.exports = __webpack_public_path__ + "img/350.e75b2efe.png";